export default __webpack_public_path__ + "static/media/IIT DELHI.a2153ac6.png";